export default __webpack_public_path__ + "static/media/project-forkify.2452c59e.jpg";